import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { filterUserPrivilegeResourceListActions } from 'saga/acl/ducks';
import {
  selectFilterUserPrivilegeResourceList,
  selectNotExistingUserPrivilegeResources,
} from 'saga/acl/userPrivilegeResources/ducks';

export const useFilterUserPrivilegeResourceList = (
  entityRefNo: string,
  privilegeType: string,
  resourceType: string,
  resourcesList: string[]
): string[] => {
  const notExistingUserPrivilegeResources = useSelector(selectNotExistingUserPrivilegeResources);
  const filterUserPrivilegeResourceList = useSelector(selectFilterUserPrivilegeResourceList);
  const dispatch = useDispatch();

  const hasMissingPrivileges =
    notExistingUserPrivilegeResources({
      entityRefNo,
      privilegeType,
      resourceType,
      resourcesList,
    }).length !== 0;

  useEffect(() => {
    if (hasMissingPrivileges) {
      dispatch(
        filterUserPrivilegeResourceListActions.request({
          entityRefNo,
          privilegeType,
          resourceType,
          resourcesList,
        })
      );
    }
    // this is intended due to payload changes not required to trigger update, since check is done above with missing privileges
  }, [hasMissingPrivileges, dispatch]);

  return filterUserPrivilegeResourceList({
    entityRefNo,
    privilegeType,
    resourceType,
    resourcesList,
  });
};
